/* eslint-disable */
__webpack_public_path__ = window.ICP_PUBLIC_PATH;
